import React from "react";

import { Button } from "../../../components/Field";
import Text from "../../../components/Text";
import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Editor from "../../../components/Editor";
import Section from "../../../components/Section";
import Background from "../../../components/Background";

import style from "./style.module.css";

export default function CallToAction(props) {
    const {
        items = []
    } = props;

    if (!items.length || !items[0]) return null;

    return (
        <Section className={`${style.callToAction} ${style[items[0].cta_type]} ${items[0].background === "color" && style[items[0].background_color]} ${style[items[0].image_direction]} ${items[0].cta_type === "text_only" && style[items[0].content_align]} `}>
            {
                items[0].background === "image" && (
                    <Background src={items[0].background_image} size="1375x550" cPosition="bottomRight" />
                )
            }
            {
                items[0].cta_type !== "large_image_and_text" && items[0].content_align !== "left" && (
                    <Spacer size={"65"} />
                )
            }
            {
                items[0].cta_type === "text_only" && items[0].content_align === "left" && (
                    <Spacer size={"65"} />
                )
            }
            <div className={`${style.callToActionWrap} ${style.wrapWidth}`}>
                <div className={style.callToActionRow}>
                    {
                        items[0].image !== "" && items[0].cta_type !== "text_only" && (
                            <div className={style.callToActionImage}>
                                <div className={style.callToActionImageWrap}>
                                    <Background src={items[0].image} size="500x500" cPosition="bottomLeft" />
                                </div>
                            </div>
                        )
                    }
                    <div className={style.callToActionContentRow}>
                        {
                            items[0].cta_type === "large_image_and_text" && items[0].image_direction !== "center" && (
                                <Spacer size={"65"} />
                            )
                        }
                        <div className={style.callToActionTextContent}>
                            {
                                items[0].name !== null && (
                                    <div className={style[items[0].title_color] ? ` ${style[items[0].title_color]}` : ""}>
                                        <Title
                                            className="fontTeko"
                                            tag="h3"
                                            transform="uppercase"
                                        >
                                            {items[0].name}
                                        </Title>
                                    </div>
                                )
                            }
                            {
                                items[0].cta_text !== null && (
                                    <div className={`${style.description}${style[items[0].text_color] ? ` ${style[items[0].text_color]}` : ""}`}>
                                        <Editor text={items[0].cta_text} />
                                    </div>
                                )
                            }
                        </div>
                        {
                            (items[0].cta_button_items || []).length > 0 && (
                                <>
                                    <Spacer size="40" />
                                    <div className={style.buttonRow}>
                                        {
                                            items[0].cta_button_items.map((item, index) => {
                                                return (
                                                    <Button
                                                        color={item.button_type}
                                                        key={`cta_button_${index}`}
                                                        label={item.button_label}
                                                        link={item.button_link}
                                                    />
                                                )
                                            })
                                        }
                                    </div>
                                </>
                            )
                        }
                        {
                            items[0].bottom_text !== null && ["large_image_and_text", "image_and_text"].includes(items[0].cta_type) && items[0].image_direction !== "center" && (
                                <>
                                    <Spacer size="40" />
                                    <div className={style[items[0].text_color] ? ` ${style[items[0].text_color]}` : ""}>
                                        <Text text={items[0].bottom_text} />
                                    </div>
                                </>
                            )
                        }
                        {
                            items[0].cta_type === "large_image_and_text" && items[0].image_direction !== "center" && (
                                <Spacer size={"65"} />
                            )
                        }
                    </div>
                </div>
            </div>
        </Section>
    )
}